import styled from 'styled-components';
import Color from 'color';

import withTheme from '../../Theme';
import Dots from './Dots.png';
import wood from './wood.jpg';

interface BoardProps {
  width: number,
  height: number,
  theme: any,
  scale: number,
  board: string
}

export const Board = withTheme((styled.div`
  background: url(${wood}) center;
  padding: ${({ theme }) => theme.board.border}px;
  border-radius: ${({ theme }) => theme.board.borderRadius}px;

  width: ${({ width, theme }: BoardProps) => width + (theme.board.side * 2)}px;

  box-sizing: content-box;
  position: relative;

  @media (max-width: ${({ theme }) => theme.media.md}px) {
    margin: 0 auto;
  }

  .border {
    padding: ${({ theme }) => theme.board.yMargin}px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background: #1a1a1a;

    border-radius: ${({ theme }) => theme.board.borderRadius}px;
  
    width: ${({ width, theme }: BoardProps) => width + (theme.board.side * 2)}px;
    height: ${({ height }: BoardProps) => height}px;

    border-left: ${({ theme, scale }) => theme.board.side}px solid ${({ theme }) => theme.colors.primary};
    border-right: ${({ theme, scale }) => theme.board.side}px solid ${({ theme }) => theme.colors.primary};

    /* box-sizing: initial; */
    &:before {
      content: ' ';
      background: url(${Dots}) #171717 left top;
      background-size: ${({ scale }) => (scale * 9.6)}px;
      width: ${({ width }: BoardProps) => width}px;
      /* height: ${({ height, theme, scale }: BoardProps) => (
        ((height / scale) * theme.dotsScale(height / scale, scale)) - (theme.board.yMargin * 2)
      )}px; */
      height: ${({ height, scale }) => height - (height % (scale * 7.2)) + (scale * 1.6)}px;
    }

    /* .shadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      box-shadow: 0 0 50px inset #1a1a1a;
    } */
    .bigshadow {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1;
      box-shadow: 0 0 ${({ width }: BoardProps) => width}px inset #000;
    }
  }

`));